<template>
  <div class="acts">
    <div class="acts__header filters-bar">
      <acts-filter />
      <i-button
        v-if="getContractModulePerms('contract_acts', 'update')"
        type="success"
        @click="createAct"
      >
        Создать акт
      </i-button>
    </div>
    <card dis-hover :padding="8" class="acts__stats stats-block special">
      <inline-loader :loading="statsLoading" v-if="statsLoading" />
      <acts-stats v-else-if="stats" :stats="stats" />
    </card>
    <inline-loader :loading="loading" v-if="loading && !nodata" />
    <div class="ms-nodata ms-text" v-else-if="!loading && nodata">
      Не удалось загрузить список актов. Повторите, пожалуйста, попытку позже
    </div>
    <template v-else-if="acts.length">
      <acts-list :acts="acts" @open-act="openAct" v-if="actsMode === 'list'" />
      <acts-groups
        :acts="acts"
        :act-statuses="actStatuses"
        @open-act="openAct"
        @change-act-status="changeActStatus"
        v-else
      />
    </template>
    <div v-else class="ms-nodata ms-text">Акты отсутствуют</div>

    <modal
      v-if="!loading"
      class-name="acts-editor editor-modal"
      v-model="actModal"
      width="720"
      :styles="{ top: '40px' }"
      :mask-closable="false"
    >
      <acts-editor-header slot="header" :act="act" />
      <div class="acts-editor__container">
        <alert
          style="margin-top: 16px"
          v-if="editorState.warning"
          class="alerts-item"
          type="warning"
        >
          {{ editorState.warning }}
        </alert>
        <acts-editor-state :act="act" :act-statuses="actStatuses" />
        <acts-editor-info
          :contract="contract"
          :act="act"
          :roadmap="roadmap"
          :act-modal="actModal"
        />
        <acts-editor-costs :act="act" :roadmap="roadmap" />
        <resources-editor type="acts" :parent="act" />
      </div>
      <div slot="footer" class="acts-editor__buttons">
        <i-button
          :disabled="
            !act.id || !getContractModulePerms('contract_acts', 'delete')
          "
          type="error"
          size="default"
          @click="handleDelete"
        >
          Удалить
        </i-button>
        <i-button
          type="success"
          size="default"
          :loading="saving"
          @click="saveAct"
          :disabled="
            editorState.disabled ||
              !getContractModulePerms('contract_acts', 'update')
          "
        >
          Сохранить
        </i-button>
      </div>
    </modal>

    <modal :z-index="2000" v-model="deleteModal" width="360">
      <p slot="header" style="color: #f60; text-align: center">
        <icon type="ios-information-circle" />
        <span style="margin-left: 4px">Удаление акта</span>
      </p>
      <div style="text-align: center">
        <p class="ms-text">Вы уверены, что хотите удалить данный акт?</p>
      </div>
      <div slot="footer">
        <i-button
          type="error"
          size="default"
          long
          :loading="deleteLoading"
          @click="deleteAct"
        >
          Удалить
        </i-button>
      </div>
    </modal>
  </div>
</template>

<script>
import cloneDeep from 'lodash.clonedeep'
import ActsList from '@/components/acts/acts-list'
import ActsGroups from '@/components/acts/acts-groups'
import InlineLoader from '@/components/loaders/inline-loader'
import ActsStats from '@/components/stats/acts-stats'
import ActsEditorHeader from '@/components/acts/editor/acts-editor-header'
import ActsEditorInfo from '@/components/acts/editor/acts-editor-info'
import ActsEditorCosts from '@/components/acts/editor/acts-editor-costs'
import ActsEditorState from '@/components/acts/editor/acts-editor-state'
import ActsFilter from '@/components/filters/acts'
import ResourcesEditor from '@/components/resources/editor/resources-editor-simple'
import { act } from '@/config/acts'
import { getActsUrl } from '@/config/filters'
import { formatDefaultDate, parseDateToServer } from '@/utils'

export default {
  props: ['type'],
  components: {
    ActsList,
    ActsGroups,
    InlineLoader,
    ActsStats,
    ActsEditorHeader,
    ActsEditorInfo,
    ActsEditorCosts,
    ActsEditorState,
    ResourcesEditor,
    ActsFilter
  },
  data () {
    return {
      stats: null,
      statsLoading: false,
      loading: false,
      nodata: false,
      roadmap: [],
      actStatuses: [],
      acts: [],
      contract: null,
      actModal: false,
      deleteLoading: false,
      deleteModal: false,
      deletingId: null,
      saving: false,
      act
    }
  },
  computed: {
    editorState () {
      const {
        number,
        act_status_id,
        act_roadmaps,
        send_date,
        sign_date,
        object_resources
      } = this.act

      // common fields
      const filteredRoadmaps = act_roadmaps.filter(r => !r.disabled)
      if (!number || !act_status_id || !filteredRoadmaps.length) {
        return {
          disabled: true,
          warning: 'Необходимо указать номер акта и включенные в него этапы'
        }
      }

      // // existing act with same number
      // const actsNumbers = this.acts.map(a => a.number)

      // if (!id && actsNumbers.includes(number)) {
      //   return {
      //     disabled: true,
      //     warning: 'Акт с указанным номером уже существует'
      //   }
      // }

      // check roadmaps costs
      if (act_roadmaps.some(r => !r.costs)) {
        return {
          disabled: true,
          warning:
            'Необходимо указать сумму по акту для каждого из выбранных этапов'
        }
      }

      // check sign status
      const status = this.actStatuses.find(s => s.id === act_status_id)
      const sendStatuses = [
        'На согласовании в компании',
        'Подписан',
        'Оплачен'
      ]
      if (sendStatuses.includes(status.name) && !send_date) {
        return {
          disabled: true,
          warning: 'Необходимо указать дату отправки акта Заказчику'
        }
      }
      // if (send_date && !sendStatuses.includes(status.name)) return false
      const signStatuses = ['Подписан', 'Оплачен']
      if (signStatuses.includes(status.name) && !sign_date) {
        return {
          disabled: true,
          warning:
            'Необходимо указать дату подписания акта, если статус акта "Подписан" или "Оплачен"'
        }
      }
      // if (sign_date && !signStatuses.includes(status.name)) return false

      // check documents
      if (signStatuses.includes(status.name) && !object_resources.length) {
        return {
          disabled: true,
          warning:
            'Необходимо приложить документы к акту, если статус акта "Подписан" или "Оплачен"'
        }
      }

      return {
        disabled: false,
        warning: null
      }
    },
    actsMode () {
      return this.$store.state.filters.actsMode
    }
  },
  watch: {
    '$store.state.filters.acts': {
      handler: function () {
        this.getActs()
      },
      deep: true
    }
    // '$store.state.socket': {
    //   handler: function (val) {
    //     if (!val.create && !val.update && !val.delete) return
    //     const { type } = this.$store.state.socket

    //     if (type === 'acts' || type === 'act_roadmaps') {
    //       this.getRoadmaps()
    //       this.getActs()
    //       this.getStats()
    //     }

    //     this.$store.commit('CLEAR_SOCKET_STATE')
    //   },
    //   deep: true,
    //   immediate: true
    // }
  },
  methods: {
    createAct () {
      this.act = cloneDeep(act)
      const status = this.actStatuses.find(
        s => s.name === 'На согласовании в компании'
      )
      if (status) this.act.act_status_id = status.id
      this.actModal = true
    },
    async openAct (act) {
      // format dates
      if (act.send_date) act.send_date = formatDefaultDate(act.send_date)
      if (act.sign_date) act.sign_date = formatDefaultDate(act.sign_date)
      // modify roadmap
      act.act_roadmaps = act.act_roadmaps.map(stage => {
        const current = this.roadmap.find(r => r.id === stage.roadmap_id)
        const {
          name,
          roadmap_start_date,
          roadmap_end_date,
          cost_lag
        } = current

        return {
          ...stage,
          name,
          roadmap_start_date,
          roadmap_end_date,
          cost_lag: cost_lag + stage.costs,
          costs: stage.costs,
          prepaid_value: stage.prepaid_value
        }
      })

      this.act = {
        ...act,
        object_resources: []
      }
      this.actModal = true
    },
    async changeActStatus ({ id, act_status_id }) {
      const contractId = this.$route.params.id

      try {
        this.$Loading.start()
        const url = `page/act?contract_id=${contractId}`
        const data = { id, act_status_id }
        await this.$store.dispatch('POST_REQUEST', { url, data })

        this.updateData()

        this.$Message.success('Сохранение данных выполнено успешно')
        this.$Loading.finish()
      } catch (error) {
        console.log(error)
        this.$Message.error('Произошла ошибка при сохранении данных')
        this.$Loading.finish()
      }
    },
    async getStats () {
      const { id } = this.$route.params

      try {
        this.statsLoading = true
        const url = `page/act_stat/${id}`
        this.stats = await this.$store.dispatch('GET_REQUEST', { url })
        this.statsLoading = false
      } catch (error) {
        console.log(error)
        this.statsLoading = false
      }
    },
    async getData () {
      const { id } = this.$route.params

      try {
        this.loading = true
        const contractUrl = `page/${this.type}/${id}`
        const actStatusesUrl = `objectInfo/act_statuses`

        this.contract = await this.$store.dispatch('GET_REQUEST', {
          url: contractUrl
        })
        this.actStatuses = await this.$store.dispatch('GET_REQUEST', {
          url: actStatusesUrl
        })
        await this.getRoadmaps()
        await this.getActs()

        this.loading = false
      } catch (error) {
        console.log(error)
        this.nodata = true
        this.loading = false
      }
    },
    async getActs () {
      const { id } = this.$route.params

      try {
        const url = getActsUrl(
          `page/act?contract_id=${id}&`,
          this.$store.state.filters.acts
        )
        this.acts = await this.$store.dispatch('GET_REQUEST', { url })
      } catch (error) {
        console.log(error)
      }
    },
    async getRoadmaps () {
      const { id } = this.$route.params
      const roadmapUrl = `page/roadmap_act_cost_lag/${id}`

      this.roadmap = await this.$store.dispatch('GET_REQUEST', {
        url: roadmapUrl
      })
    },
    handleDelete () {
      this.deletingId = this.act.id
      this.deleteModal = true
    },

    async deleteAct () {
      try {
        this.deleteLoading = true

        const url = `page/act?id=${this.act.id}`

        await this.$store.dispatch('DELETE_REQUEST', { url })

        this.updateData()

        this.$Message.success('Удаление данных выполнено успешно')
        this.deleteLoading = false
        this.deletingId = null
        this.deleteModal = false
        this.actModal = false
      } catch (error) {
        console.log(error)
        this.$Message.error('Произошла ошибка при удалении данных')
        this.deleting = false
      }
    },
    async saveAct () {
      const { id } = this.$route.params

      try {
        this.saving = true
        const url = `page/act?contract_id=${id}`
        const data = this.getActData()

        await this.$store.dispatch('POST_REQUEST', { url, data })

        this.act = { ...act }
        this.$Message.success('Сохранение данных выполнено успешно')

        this.updateData()

        this.saving = false
        this.actModal = false
      } catch (error) {
        console.log(error)
        this.$Message.error('Произошла ошибка при сохранении данных')
        this.saving = false
      }
    },
    getActData () {
      const {
        act_roadmaps,
        act_status_id,
        number,
        id,
        send_date,
        sign_date,
        is_original_exists,
        object_resources
      } = this.act

      return {
        contract_id: this.contract.id,
        act_status_id,
        act_roadmaps: act_roadmaps.map(r => ({
          id: r.id,
          roadmap_id: r.roadmap_id,
          costs: r.costs,
          prepaid_value: r.prepaid_value,
          disabled: r.disabled
        })),
        number,
        costs: act_roadmaps
          .filter(r => !r.disabled)
          .reduce((prev, el) => prev + el.costs, 0),
        send_date: parseDateToServer(send_date),
        sign_date: parseDateToServer(sign_date),
        id,
        object_resources: id ? undefined : object_resources,
        is_original_exists
      }
    },
    updateData () {
      this.getRoadmaps()
      this.getActs()
      this.getStats()
    }
  },
  async created () {
    await this.getData()
    this.getStats()

    const { open } = this.$route.query
    if (open) this.openAct({ id: open })
  }
}
</script>

<style lang="less">
.acts {
  &__stats {
    margin-bottom: 16px;
  }
}

.acts-editor {
  .ivu-modal-body {
    padding-top: 0;
  }

  &__buttons {
    display: flex;
    justify-content: space-between;
  }
}
</style>
